<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <XrfGroupForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import XrfGroupForm from '@/components/organisms/master/form/XrfGroupForm'

export default {
  name: 'XrfGroupPage',

  components: {
    XrfGroupForm,
  },
}
</script>
